var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadSalmon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 31,
    viewBox: "0 0 37 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1308 8.95434L18.4939 15.3174L24.8569 8.95434",
    stroke: "#E4897B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4938 15.3174V1.00052",
    stroke: "#E4897B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.14665 5.15001C3.59511 5.99586 2.36944 7.33431 1.66308 8.95412C0.956712 10.5739 0.809885 12.3828 1.24577 14.0954C1.68165 15.8079 2.67541 17.3265 4.07022 18.4115C5.46503 19.4965 7.18144 20.0861 8.94857 20.0873H10.9529C11.4344 21.9497 12.3319 23.6787 13.5778 25.1443C14.8237 26.6099 16.3856 27.7741 18.1462 28.5492C19.9068 29.3242 21.8201 29.6901 23.7425 29.6193C25.6648 29.5485 27.5461 29.0428 29.2448 28.1402C30.9436 27.2377 32.4156 25.9618 33.5503 24.4084C34.685 22.8551 35.4527 21.0647 35.7959 19.1719C36.139 17.2792 36.0486 15.3332 35.5314 13.4804C35.0143 11.6276 34.0838 9.91614 32.81 8.4747",
    stroke: "#E4897B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadSalmon);
export default __webpack_public_path__ + "static/media/download_salmon.3613d56815d61a77591fd68bc9699fdc.svg";
export { ForwardRef as ReactComponent };